module.exports = __webpack_public_path__ + "img/teacher-nan.360336a5.png";